function launchAjaxSearch(form) {
    var searchRequest = $.ajax({
        url: window.tokilab_ajax_object.resources_center_url + '?' + form.serialize() ,
        type: 'POST',
        data: {
            action: 'ajax_resources_ovivo',
        },
        success: function success(data) {
            var jqObj = jQuery(data);
            $('.fc-ajax-resources-results', '.page-digital').html(jqObj.find('.fc-ajax-resources-results > div'));
            searchRequest = null;
        },
    });
    return searchRequest;
}

export default {
    finalize() {
        var searchRequest = null;

        $(document).on('click', '.allow-focus', function (e) {
            e.stopPropagation();
        });

        $('.fc-select_all').on('click', function (){
            var current_select = $(this);
            var dropdown = current_select.parents('.dropdown-menu');

            if (searchRequest != null) {
                searchRequest.abort();
            }

            var count = dropdown.find('ul').find('input[type=checkbox]:checked').length;
            if(count == 0) {
                dropdown.find('ul').find('input[type="checkbox"]').each(function () {
                    $(this).prop('checked', true);
                });
            } else {
                dropdown.find('ul').find('input[type="checkbox"]').each(function () {
                    $(this).prop('checked', false);
                });
            }
            // if(current_select.is(':checked')) {
            //     dropdown.find('ul').find('input[type="checkbox"]').each(function () {
            //         $(this).prop('checked', true);
            //     });
            // } else {
            //     dropdown.find('ul').find('input[type="checkbox"]').each(function () {
            //         $(this).prop('checked', false);
            //     });
            // }
            setTimeout(() => {
                var count = dropdown.find('ul').find('input[type=checkbox]:checked').length;
                dropdown.find('.fc-fieldset-count').empty().html(count + '&nbsp;' +  window.tokilab_ajax_object.selected_label);
                searchRequest = launchAjaxSearch($('.page-digital__filters--search-form'));
            }, 100);
        });

        $('.dropdown-menu input[type=checkbox]').each(function () {
            var current_select = $(this);
            var dropdown = current_select.parents('.dropdown-menu');

            var button_parent = current_select.parents('.page-digital__filters--dropdown-wrapper').find('.page-digital__filters--dropdown-toggle');
            current_select.on('click', function(){
                setTimeout(() => {
                    var count = dropdown.find('ul').find('input[type=checkbox]:checked').length;
                    dropdown.find('.fc-fieldset-count').html(count + '&nbsp;' +  window.tokilab_ajax_object.selected_label);
                    if(count == 0) {
                        button_parent.find('span').eq(1).text('');
                    } else {
                        button_parent.find('span').eq(1).text('('+count+')');
                    }
                    if(count > 0) {
                        // current_select.parents('.page-digital__filters--dropdown-wrapper').find('.fc-select_all').prop('checked', true);
                        current_select.parents('.page-digital__filters--dropdown-wrapper').find('.fc-select_all_label').find('span').eq(1).show();
                        current_select.parents('.page-digital__filters--dropdown-wrapper').find('.fc-select_all_label').find('span').eq(0).hide();
                    } else {
                        // current_select.parents('.page-digital__filters--dropdown-wrapper').find('.fc-select_all').prop('checked', false);
                        current_select.parents('.page-digital__filters--dropdown-wrapper').find('.fc-select_all_label').find('span').eq(1).hide();
                        current_select.parents('.page-digital__filters--dropdown-wrapper').find('.fc-select_all_label').find('span').eq(0).show();
                    }
                    if (searchRequest != null) {
                        searchRequest.abort();
                    }
                    searchRequest = launchAjaxSearch($('.page-digital__filters--search-form'));
                }, 100);
            })
        });

        $($('.page-digital__filters--dropdown')).each(function () {
            var $this = $(this);
            $this.on('show.bs.dropdown', function () {
                return false;
            });
        });

        // $('.page-digital__filters--search-form').on('submit', function(e) {
        //     e.preventDefault();
        //     var searchRequest = launchAjaxSearch($(this));
        //     if (typeof searchRequest != 'undefined' && searchRequest != null) {
        //         console.log('abort');
        //         searchRequest.abort();
        //     }
        // });
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/postTypeArchiveDigtalAsset.js